import { SellerRatingItem, SellerRatingPreloader } from '@components/SellerRatingItem';
import { SellerRatingWithReviewsCount } from '@components/SellerRatingWithReviewsCount';
import s from '@components/SellerRatingItem/SellerRatingItem.sss';

import { useSellerRatingInfoQuery } from './graphql.v3.generated';

type SellerRatingModalContainerProps = {
  sellerId: number;
};

export const SellerRatingModalContainer: React.FC<SellerRatingModalContainerProps> = (
  {
    sellerId,
  },
) => {
  const { data, loading } = useSellerRatingInfoQuery({
    variables: { id: sellerId },
    context: {
      batch: true,
    },
  });

  if (loading) {
    return <SellerRatingPreloader />;
  }

  const sellerRatingInfo = data?.user?.sellerRatingInfo;

  if (!sellerRatingInfo) {
    return null;
  }

  return (
    <div>
      <SellerRatingWithReviewsCount
        userName={data?.user?.username}
        className={s.reviewsCount}
        overallRating={sellerRatingInfo?.overallRating}
        reviewsCount={sellerRatingInfo?.reviewsCount}
        reviewsCountByPeriod={sellerRatingInfo?.reviewsCountByPeriod}
      />
      {
        sellerRatingInfo.blocks.map((block, i) => {
          if (block.items) {
            return (
              <SellerRatingItem
                key={i}
                sellerRatingItems={block.items}
              />
            );
          }

          return null;
        })
      }
    </div>
  );
};
